import React, { createContext } from "react";

// Theme context - simplified for light mode only
const ThemeContext = createContext({
  theme: "light",
});

const ThemeProvider = ({ children }) => {
  return (
    <ThemeContext.Provider value={{ theme: "light" }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook for using theme
const useTheme = () => {
  const context = React.useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

export { ThemeProvider, useTheme };
